import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  cursor: pointer;
`;

export const Heading = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  margin: 28px 16px 13px 16px;
  flex-direction: row;
  h4 {
    margin: 0;
    font-size: 1.6rem;
    font-weight: 500;
  }
`;
